<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/registry']"
        >
          Registry
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/qaRun']"
        >
          QA Run
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/internalLinks']"
        >
          Internal Links
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageDashboard']"
        >
          On-P Insights
        </a>
      </div>
    </div>
  </div> -->

  <!-- <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a class="btn btn-dark btn-sm btn-reg"> Keywords </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageRecommendations']"
        >
          Off-P Recomm
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageProspects']"
        >
          Off-P Prospects
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageBacklinks']"
        >
          Off-P Backlinks
        </a>
      </div>
    </div>
  </div> -->

  <div class="row">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a class="btn btn-dark btn-sm btn-reg"> Keywords </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPageCampaigns/urlMapping']"
        >
          URL Mapping
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/onPage']"
        >
          On-Page
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/internalLinks/add']"
        >
          Internal Links
        </a>
      </div>
    </div>
  </div>

  <div class="row pb-3">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/technicalQa']"
        >
          Technical QA
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/localSeo']"
        >
          Local SEO
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/offPage']"
        >
          Off-Page
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/marketing/seo/performance']"
        >
          Performance
        </a>
      </div>
    </div>
  </div>

  <div class="keywords-container p-3">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="d-flex align-items-center gap-3">
        <div class="header-icon bg-primary text-white rounded p-2">
          <i class="fas fa-location-crosshairs fa-lg"></i>
        </div>
        <div class="pl-2">
          <h2 class="h4 mb-0 fw-bold">KEYWORDS</h2>
          <!-- <p class="text-muted mb-0 small">
            Discover, evaluate, and manage keyword opportunities before
            architural processing.
          </p> -->
        </div>
      </div>
      <div class="d-flex gap-2">
        <button
          class="btn btn-sm btn-add p-1 ml-1 btn-header"
          [routerLink]="['/marketing/seo/offPageCampaigns/add']"
        >
          NEW KEYWORD SEARCH
        </button>
      </div>
    </div>

    <div class="card px-1 py-4 mb-4 shadow-sm custom-scroll-x">
      <div class="row align-items-center m-0 flex-nowrap">
        <div class="col-md-3" style="min-width: 220px">
          <mat-form-field
            appearance="outline"
            class="w-100 compact-search-field"
            subscriptSizing="dynamic"
            floatLabel="always"
          >
            <mat-label>Search location</mat-label>
            <input
              #locInput
              #locTrigger="matAutocompleteTrigger"
              type="text"
              matInput
              [(ngModel)]="selectedLocation"
              (ngModelChange)="onLocationSearch($event)"
              [matAutocomplete]="autoCity"
              placeholder="Search location..."
            />
            <mat-autocomplete
              #autoCity="matAutocomplete"
              (optionSelected)="
                selectLocation($event.option.value);
                locTrigger.closePanel();
                locInput.blur()
              "
            >
              <mat-option
                *ngFor="let location of filteredLocations"
                [value]="location"
              >
                {{ location }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="col-md-2" style="min-width: 220px">
          <mat-form-field
            appearance="outline"
            class="w-100 compact-search-field"
            subscriptSizing="dynamic"
            floatLabel="always"
          >
            <mat-label>Search universe</mat-label>
            <input
              #uniInput
              #uniTrigger="matAutocompleteTrigger"
              type="text"
              matInput
              [(ngModel)]="selectedUniverse"
              (ngModelChange)="onUniverseSearch($event)"
              [matAutocomplete]="autoService"
              placeholder="Search universe..."
            />
            <mat-autocomplete
              #autoService="matAutocomplete"
              (optionSelected)="
                selectUniverse($event.option.value);
                uniTrigger.closePanel();
                uniInput.blur()
              "
              [displayWith]="displayUniverseFn"
            >
              <mat-option
                *ngFor="let universe of filteredUniverses"
                [value]="universe"
              >
                {{ getUniverseLabel(universe) | titlecase }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="col-md-3" style="min-width: 220px">
          <mat-form-field
            appearance="outline"
            class="w-100 compact-search-field"
            subscriptSizing="dynamic"
            floatLabel="always"
          >
            <mat-label>Search category</mat-label>
            <input
              #catInput
              #catTrigger="matAutocompleteTrigger"
              type="text"
              matInput
              [(ngModel)]="selectedCategory"
              (ngModelChange)="onCategorySearch($event)"
              [matAutocomplete]="autoCategory"
              placeholder="Search category..."
            />
            <mat-autocomplete
              #autoCategory="matAutocomplete"
              (optionSelected)="
                selectCategory($event.option.value);
                catTrigger.closePanel();
                catInput.blur()
              "
              [displayWith]="displayCategoryFn"
            >
              <mat-option
                *ngFor="let category of filteredCategories"
                [value]="category"
              >
                {{ getCategoryLabel(category) | titlecase }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <!-- Selected Scope box -->
        <div class="col-md-4" style="min-width: 220px">
          <button
            class="btn btn-dark btn-sm btn-filter btn-add mb-0"
            (click)="filter()"
          >
            Find
          </button>
          <!-- <div
            class="selected-scope-box bg-light border p-2 rounded d-flex gap-3 w-100"
            *ngIf="selectedLocation || selectedUniverse || selectedCategory"
            style="min-height: 52px; padding: 0.75rem 1rem !important"
          >
            <div class="selected-scope-icon text-dark flex-shrink-0">
              <i class="fa-solid fa-location-crosshairs fa-lg pr-2"></i>
            </div>
            <div class="selected-scope-content d-flex flex-column">
              <span
                class="text-dark fw-bold"
                style="font-size: 0.8rem; margin-bottom: 2px"
                >Selected Scope</span
              >
              <div
                class="selected-scope-path text-dark fw-normal"
                style="font-size: 0.75rem"
              >
                <span *ngIf="selectedLocation">{{
                  selectedLocation | titlecase
                }}</span>
                <span
                  *ngIf="selectedLocation && selectedUniverse"
                  class="scope-sep mx-1 text-muted"
                >
                  >
                </span>
                <span *ngIf="selectedUniverse">{{
                  getUniverseLabel(selectedUniverse) | titlecase
                }}</span>
                <span
                  *ngIf="selectedUniverse && selectedCategory"
                  class="scope-sep mx-1 text-muted"
                >
                  >
                </span>
                <span *ngIf="selectedCategory">{{
                  getCategoryLabel(selectedCategory) | titlecase
                }}</span>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <!-- <div class="row mb-4">
    <div class="col-12">
      <a
        class="btn btn-dark btn-sm btn-new-sm"
        [routerLink]="['/marketing/seo/offPageCampaigns/add']"
      >
        NEW
      </a>
    </div>
  </div> -->

    <!-- <div
    class="card shadow-sm"
    *ngIf="selectedCity && selectedService && filteredData.length > 0"
  >
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Campaign</th>
              <th>City</th>
              <th>Keywords</th>
              <th>Ranking</th>
              <th>Service</th>
              <th>Landing</th>
              <th>URL</th>
              <th>Type</th>
              <th>Status</th>
              <th>Priority</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td
                class="title-cell"
                (click)="showModal('Title', item.title)"
                title="Click to view full URL"
              >
                {{ item.title }}
              </td>
              <td class="city-cell">{{ item.city | titlecase }}</td>
              <td
                class="title-cell"
                (click)="showModal('Keywords', getKeywords(item))"
                title="Click to view full keywords"
              >
                <div class="keyword-list-container">
                  <ul
                    class="mb-0 ps-3"
                    *ngIf="getKeywords(item).length > 0; else noKws"
                  >
                    <li
                      *ngFor="let kw of getKeywords(item)"
                      [ngClass]="{
                        'text-muted text-decoration-line-through':
                          kw.status === 'disabled',
                        'text-warning': kw.status === 'paused',
                      }"
                    >
                      {{ kw.value }}
                    </li>
                  </ul>
                  <ng-template #noKws>-</ng-template>
                </div>
              </td>
              <td class="city-cell"></td>
              <td class="city-cell">{{ item.service }}</td>
              <td>{{ item.landingType }}</td>
              <td class="city-cell">
                <a [href]="item.targetUrl" target="_blank" class="text-info">
                  <i class="fas fa-external-link-alt"></i> Link
                </a>
              </td>
              <td>{{ item.campaignType }}</td>
              <td>
                <span
                  class="badge"
                  [ngClass]="getStatusBadgeClass(item.status)"
                >
                  {{ item.status | uppercase }}
                </span>
              </td>
              <td>
                <span
                  class="badge"
                  [ngClass]="getPriorityBadgeClass(item.priority)"
                >
                  {{ item.priority | uppercase }}
                </span>
              </td>
              <td class="text-nowrap">
                <a
                  class="btn btn-link text-info btn-sm"
                  [routerLink]="[
                    '/marketing/seo/offPageCampaigns/view',
                    item._id,
                  ]"
                  title="View"
                >
                  <i class="fas fa-eye"></i>
                </a>
                <a
                  class="btn btn-link text-dark btn-sm"
                  [routerLink]="[
                    '/marketing/seo/offPageCampaigns/edit',
                    item._id,
                  ]"
                  title="Edit"
                >
                  <i class="fas fa-pen"></i>
                </a>

                <button
                  *ngIf="
                    item.status === 'planned' || item.status === 'research'
                  "
                  (click)="approve(item._id)"
                  class="btn btn-link text-success btn-sm"
                  title="Approve"
                >
                  <i class="fas fa-check-circle"></i>
                </button>

                <button
                  *ngIf="item.status === 'approved' || item.status === 'paused'"
                  (click)="changeStatus(item._id, 'in_progress')"
                  class="btn btn-link text-primary btn-sm"
                  title="Start"
                >
                  <i class="fas fa-play"></i>
                </button>

                <button
                  *ngIf="item.status === 'in_progress'"
                  (click)="changeStatus(item._id, 'paused')"
                  class="btn btn-link text-warning btn-sm"
                  title="Pause"
                >
                  <i class="fas fa-pause"></i>
                </button>

                <button
                  *ngIf="item.status === 'in_progress'"
                  (click)="complete(item._id)"
                  class="btn btn-link text-success btn-sm"
                  title="Complete"
                >
                  <i class="fas fa-flag-checkered"></i>
                </button>

                <button
                  (click)="deleteData(item._id)"
                  class="btn btn-link text-danger btn-sm"
                  title="Delete"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div> -->

    <div class="row mt-1">
      <div class="col-12">
        <div class="card shadow-sm mt-0">
          <!-- KEYWORD PORTFOLIO OVERVIEW header -->
          <div
            class="portfolio-header d-flex align-items-center justify-content-between px-3 py-2"
          >
            <span class="portfolio-title"
              ><strong>KEYWORD PORTFOLIO OVERVIEW</strong></span
            >
            <!-- <div class="d-flex align-items-center gap-3">
              <span class="last-updated-text text-muted font-size-12">
                Last updated: {{ lastUpdated | date: "MMM d, yyyy" }}
                <button
                  class="btn btn-link btn-sm p-0 ms-1"
                  (click)="getData()"
                  title="Refresh"
                >
                  <i
                    class="fas fa-sync-alt text-secondary"
                    style="font-size: 0.75rem"
                  ></i>
                </button>
              </span>
              <button
                class="btn btn-outline-secondary btn-sm btn-filter shadow-sm ml-2"
              >
                <i class="fas fa-filter me-1"></i> FILTERS
              </button>
            </div> -->
          </div>
          <!-- <div class="card-header bg-white py-3">
          <h5 class="mb-0 text-dark">
            <i class="fas fa-key me-2"></i> Keywords for
            {{ selectedCity ? (selectedCity | titlecase) : "All Cities" }}
          </h5>
        </div> -->
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-bordered mb-0">
                <thead class="thead">
                  <tr>
                    <th class="ps-3 font-size-15">
                      <strong>Keyword</strong
                      ><i
                        class="fas fa-arrows-alt-v ms-1 text-muted small pl-1"
                      ></i>
                    </th>
                    <th class="text-center font-size-15">
                      <strong>Current Pos.</strong
                      ><i
                        class="fas fa-info-circle ms-1 text-muted small pl-1"
                      ></i>
                    </th>
                    <th class="text-center font-size-15">
                      <strong>Prev. Pos.</strong
                      ><i
                        class="fas fa-info-circle ms-1 text-muted small pl-1"
                      ></i>
                    </th>
                    <th class="text-center font-size-15">
                      <strong>Change</strong
                      ><i
                        class="fas fa-info-circle ms-1 text-muted small pl-1"
                      ></i>
                    </th>
                    <th class="text-center font-size-15">
                      <strong>Overall Trend</strong
                      ><i
                        class="fas fa-info-circle ms-1 text-muted small pl-1"
                      ></i>
                    </th>
                    <th class="text-center font-size-15">
                      <strong>Opp. Rank</strong
                      ><i
                        class="fas fa-info-circle ms-1 text-muted small pl-1"
                      ></i>
                    </th>
                    <th class="text-center font-size-15">
                      <strong>Search Volume</strong
                      ><i
                        class="fas fa-info-circle ms-1 text-muted small pl-1"
                      ></i>
                    </th>
                    <th class="text-center font-size-15">
                      <strong>Status</strong
                      ><i
                        class="fas fa-info-circle ms-1 text-muted small pl-1"
                      ></i>
                    </th>
                    <th class="text-center font-size-15">
                      <strong>Last Check</strong
                      ><i
                        class="fas fa-info-circle ms-1 text-muted small pl-1"
                      ></i>
                    </th>
                    <th class="text-center font-size-15">
                      <strong>Actions</strong
                      ><i
                        class="fas fa-info-circle ms-1 text-muted small pl-1"
                      ></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container
                    *ngIf="
                      selectedLocation &&
                      selectedUniverse &&
                      filteredData.length > 0
                    "
                  >
                    <ng-container *ngFor="let item of filteredData">
                      <tr
                        *ngFor="
                          let kw of getKeywords(item);
                          let kwIndex = index
                        "
                      >
                        <!-- Keyword -->
                        <td class="ps-3 text-nowrap">
                          <a
                            *ngIf="kw.url"
                            [href]="kw.url"
                            target="_blank"
                            class="kw-link"
                            [ngClass]="{
                              'text-muted text-decoration-line-through':
                                kw.status === 'disabled',
                              'text-warning': kw.status === 'paused',
                            }"
                          >
                            {{ kw.value }}
                            <i class="fas fa-external-link-alt fa-xs ms-1"></i>
                          </a>
                          <span
                            *ngIf="!kw.url"
                            [ngClass]="{
                              'text-muted text-decoration-line-through':
                                kw.status === 'disabled',
                              'text-warning': kw.status === 'paused',
                            }"
                            >{{ kw.value }}</span
                          >
                        </td>

                        <!-- Current Pos. -->
                        <td class="text-center">
                          <span
                            *ngIf="
                              kw.currentPos !== undefined &&
                              kw.currentPos !== null
                            "
                            >#{{ kw.currentPos }}</span
                          >
                          <span
                            *ngIf="
                              kw.currentPos === undefined ||
                              kw.currentPos === null
                            "
                            >—</span
                          >
                        </td>

                        <!-- Prev. Pos. -->
                        <td class="text-center">
                          <span
                            *ngIf="
                              kw.prevPos !== undefined && kw.prevPos !== null
                            "
                            >#{{ kw.prevPos }}</span
                          >
                          <span
                            *ngIf="
                              kw.prevPos === undefined || kw.prevPos === null
                            "
                            >—</span
                          >
                        </td>

                        <!-- Change -->
                        <td class="text-center">
                          <ng-container
                            *ngIf="
                              kw.change !== undefined && kw.change !== null;
                              else noChange
                            "
                          >
                            <span
                              *ngIf="kw.change > 0"
                              class="text-success fw-semibold"
                            >
                              <i class="fas fa-caret-up"></i> {{ kw.change }}
                            </span>
                            <span
                              *ngIf="kw.change < 0"
                              class="text-danger fw-semibold"
                            >
                              <i class="fas fa-caret-down"></i>
                              {{ kw.change * -1 }}
                            </span>
                            <span *ngIf="kw.change === 0" class="text-muted"
                              >—</span
                            >
                          </ng-container>
                          <ng-template #noChange
                            ><span class="text-muted">—</span></ng-template
                          >
                        </td>

                        <!-- Overall Trend -->
                        <td class="text-center">
                          <ng-container [ngSwitch]="kw.trend">
                            <span
                              *ngSwitchCase="'improving'"
                              class="trend-label trend-improving"
                            >
                              <i class="fas fa-chart-line"></i> Improving
                            </span>
                            <span
                              *ngSwitchCase="'declining'"
                              class="trend-label trend-declining"
                            >
                              <i class="fas fa-chart-line fa-flip-vertical"></i>
                              Declining
                            </span>
                            <span
                              *ngSwitchCase="'stable'"
                              class="trend-label trend-stable"
                            >
                              <i class="fas fa-minus"></i> Stable
                            </span>
                            <span *ngSwitchDefault class="text-muted">—</span>
                          </ng-container>
                        </td>

                        <!-- Opp. Rank -->
                        <td class="text-center">
                          <span *ngIf="kw.oppRank">{{ kw.oppRank }}</span>
                          <span *ngIf="!kw.oppRank" class="text-muted">—</span>
                        </td>

                        <!-- Search Volume -->
                        <td class="text-center">
                          <span
                            *ngIf="
                              kw.searchVolume !== undefined &&
                              kw.searchVolume !== null
                            "
                            >{{ kw.searchVolume }}</span
                          >
                          <span
                            *ngIf="
                              kw.searchVolume === undefined ||
                              kw.searchVolume === null
                            "
                            class="text-muted"
                            >—</span
                          >
                        </td>

                        <!-- Status -->
                        <td class="text-center">
                          <span
                            class="badge"
                            [ngClass]="{
                              'badge-success': kw.status === 'active',
                              'badge-warning': kw.status === 'paused',
                              'badge-secondary': kw.status === 'disabled',
                              'badge-info': kw.status === 'banked',
                              'badge-danger': kw.status === 'review',
                            }"
                          >
                            {{ kw.status | uppercase }}
                          </span>
                        </td>

                        <!-- Last Check -->
                        <td class="text-center text-nowrap">
                          <ng-container *ngIf="kw.lastCheck; else noLastCheck">
                            <span class="last-check-date">{{
                              kw.lastCheck | date: "MMM d, yyyy"
                            }}</span>
                            <span
                              class="last-check-dot ms-1 ml-1"
                              [ngClass]="{
                                'dot-fresh':
                                  getLastCheckStatus(kw.lastCheck) === 'fresh',
                                'dot-due':
                                  getLastCheckStatus(kw.lastCheck) === 'due',
                              }"
                            ></span>
                            <span
                              class="ms-1 pl-1"
                              style="font-size: 0.8rem"
                              [ngClass]="{
                                'text-fresh':
                                  getLastCheckStatus(kw.lastCheck) === 'fresh',
                                'text-due':
                                  getLastCheckStatus(kw.lastCheck) === 'due',
                              }"
                              >{{
                                getLastCheckStatus(kw.lastCheck) === "fresh"
                                  ? "Fresh"
                                  : "Due"
                              }}</span
                            >
                          </ng-container>
                          <ng-template #noLastCheck
                            ><span class="text-muted">—</span></ng-template
                          >
                        </td>

                        <!-- Actions -->
                        <td class="text-center text-nowrap">
                          <a
                            *ngIf="kwIndex == 0"
                            class="btn btn-link text-info btn-sm p-0 mx-1"
                            [routerLink]="[
                              '/marketing/seo/offPageCampaigns/view',
                              item._id,
                            ]"
                            title="View"
                          >
                            <i class="fas fa-eye"></i>
                          </a>

                          <!-- Activar -->
                          <button
                            *ngIf="kw.status !== 'active'"
                            class="btn btn-link text-success btn-sm p-0 mx-1"
                            (click)="changeKeywordStatus(item, kw, 'active')"
                            title="Activar"
                          >
                            <i class="fas fa-play"></i>
                          </button>

                          <!-- Pausar -->
                          <button
                            *ngIf="kw.status === 'active'"
                            class="btn btn-link text-warning btn-sm p-0 mx-1"
                            (click)="changeKeywordStatus(item, kw, 'paused')"
                            title="Pausar"
                          >
                            <i class="fas fa-pause"></i>
                          </button>

                          <!-- Deshabilitar -->
                          <button
                            *ngIf="kw.status !== 'disabled'"
                            class="btn btn-link text-danger btn-sm p-0 mx-1"
                            (click)="changeKeywordStatus(item, kw, 'disabled')"
                            title="Deshabilitar"
                          >
                            <i class="fas fa-times"></i>
                          </button>

                          <!-- Eliminar -->
                          <button
                            class="btn btn-link text-danger btn-sm p-0 mx-1"
                            (click)="deleteKeyword(item, kw)"
                            title="Eliminar permanentemente"
                          >
                            <i class="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container>
                  <tr
                    *ngIf="
                      hasSearched &&
                      selectedLocation &&
                      selectedUniverse &&
                      filteredData.length === 0
                    "
                  >
                    <td colspan="10" class="text-center py-4 text-muted">
                      No data found for the selected scope.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Footer stats cards -->
          <div class="portfolio-footer px-0 py-0 border-top bg-light">
            <div
              class="row m-0 align-items-stretch flex-nowrap custom-scroll-x p-0 gap-3"
            >
              <!-- Total Keywords -->
              <div class="col-2 p-0 pr-1 d-flex" style="min-width: 175px">
                <div class="card shadow-sm border-0 bg-white w-100">
                  <div class="card-body p-3 d-flex">
                    <div class="stat-icon-filled bg-blue me-3">
                      <i class="fas fa-chart-bar"></i>
                    </div>
                    <div class="space-cards">
                      <div
                        class="text-uppercase fw-bold text-dark mb-1"
                        style="font-size: 0.63rem; letter-spacing: 0.5px"
                      >
                        <strong>TOTAL KEYWORDS</strong>
                      </div>
                      <h3 class="mb-1 fw-bold text-dark">
                        {{ portfolioStats.total }}
                      </h3>
                      <div class="small fw-medium text-muted">
                        In this scope
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Active Priority -->
              <div class="col-2 p-0 pr-1 d-flex" style="min-width: 175px">
                <div class="card shadow-sm border-0 bg-white w-100">
                  <div class="card-body p-3 d-flex">
                    <div class="stat-icon-filled bg-green me-3">
                      <i class="fas fa-check-circle"></i>
                    </div>
                    <div class="space-cards">
                      <div
                        class="text-uppercase fw-bold text-dark mb-1"
                        style="font-size: 0.63rem; letter-spacing: 0.5px"
                      >
                        <strong>ACTIVE PRIORITY</strong>
                      </div>
                      <h3 class="mb-1 fw-bold text-dark">
                        {{ portfolioStats.active }}
                      </h3>
                      <div class="small fw-medium text-muted">
                        {{ portfolioStats.activePct }}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Banked -->
              <div class="col-2 p-0 pr-1 d-flex" style="min-width: 175px">
                <div class="card shadow-sm border-0 bg-white w-100">
                  <div class="card-body p-3 d-flex">
                    <div class="stat-icon-filled bg-info-custom me-3">
                      <i class="fas fa-university"></i>
                    </div>
                    <div class="space-cards">
                      <div
                        class="text-uppercase fw-bold text-dark mb-1"
                        style="font-size: 0.63rem; letter-spacing: 0.5px"
                      >
                        <strong>BANKED</strong>
                      </div>
                      <h3 class="mb-1 fw-bold text-dark">
                        {{ portfolioStats.banked }}
                      </h3>
                      <div class="small fw-medium text-muted">
                        {{ portfolioStats.bankedPct }}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Needs Review -->
              <div class="col-2 p-0 pr-1 d-flex" style="min-width: 175px">
                <div class="card shadow-sm border-0 bg-white w-100">
                  <div class="card-body p-3 d-flex">
                    <div class="stat-icon-filled bg-orange me-3">
                      <i class="fas fa-magnifying-glass"></i>
                    </div>
                    <div class="space-cards">
                      <div
                        class="text-uppercase fw-bold text-dark mb-1"
                        style="font-size: 0.63rem; letter-spacing: 0.5px"
                      >
                        <strong>NEEDS REVIEW</strong>
                      </div>
                      <h3 class="mb-1 fw-bold text-dark">
                        {{ portfolioStats.review }}
                      </h3>
                      <div class="small fw-medium text-muted">
                        {{ portfolioStats.reviewPct }}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Archived -->
              <div class="col-2 p-0 pr-1 d-flex" style="min-width: 175px">
                <div class="card shadow-sm border-0 bg-white w-100">
                  <div class="card-body p-3 d-flex">
                    <div class="stat-icon-filled bg-secondary-custom me-3">
                      <i class="fas fa-box-archive"></i>
                    </div>
                    <div class="space-cards">
                      <div
                        class="text-uppercase fw-bold text-dark mb-1"
                        style="font-size: 0.63rem; letter-spacing: 0.5px"
                      >
                        <strong>ARCHIVED</strong>
                      </div>
                      <h3 class="mb-1 fw-bold text-dark">
                        {{ portfolioStats.archived }}
                      </h3>
                      <div class="small fw-medium text-muted">
                        {{ portfolioStats.archivedPct }}%
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Avg. Last Check -->
              <div class="col-2 p-0 d-flex" style="min-width: 200px">
                <div class="card shadow-sm border-0 bg-white w-100">
                  <div class="card-body p-3 d-flex">
                    <div class="stat-icon-filled bg-blue me-3">
                      <i class="far fa-calendar-check"></i>
                    </div>
                    <div class="space-cards">
                      <div
                        class="text-uppercase fw-bold text-dark mb-1"
                        style="font-size: 0.63rem; letter-spacing: 0.5px"
                      >
                        <strong>AVG. LAST CHECK</strong>
                      </div>
                      <h3
                        class="mb-1 fw-bold text-dark"
                        style="white-space: nowrap"
                      >
                        {{ portfolioStats.avgLastCheckDays }} days ago
                      </h3>
                      <div class="small fw-medium text-muted">
                        Across all keywords
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="mt-2 text-center text-muted" style="font-size: 0.7rem">
              Opportunity Rank is based on current market opportunity within the
              selected scope.
              <a
                href="javascript:void(0)"
                class="text-primary text-decoration-none fw-medium ms-1"
              >
                View Notes on Ranking System
                <i class="fas fa-external-link-alt ms-1"></i>
              </a>
            </div> -->
          </div>
        </div>
        <!-- /card shadow-sm -->
      </div>

      <div class="row m-auto" *ngIf="!selectedLocation || !selectedUniverse">
        <div class="col-12 text-center">
          <div class="alert alert-info shadow-sm">
            <i class="fas fa-info-circle me-2"></i>
            Please select both a location and a universe to see the campaigns.
          </div>
        </div>
      </div>
    </div>
    <!-- /keywords-container -->
  </div>
  <!-- /container-fluid -->

  <!-- Modal -->
  <div
    class="modal-url-overlay"
    *ngIf="modalContent || modalListItems"
    (click)="closeModal()"
  >
    <div class="modal-url-content" (click)="$event.stopPropagation()">
      <div class="modal-url-header">
        <h5 class="mb-0">{{ modalTitle }}</h5>
        <button type="button" class="modal-url-close" (click)="closeModal()">
          &times;
        </button>
      </div>
      <div
        class="modal-url-body text-dark"
        style="word-wrap: break-word; white-space: pre-wrap"
      >
        <ng-container *ngIf="modalContent">
          {{ modalContent }}
        </ng-container>
        <ul *ngIf="modalListItems" class="ps-3 mb-0">
          <li
            *ngFor="let kw of modalListItems"
            (click)="onKeywordAction(kw)"
            class="hover-item"
            style="cursor: pointer; padding-bottom: 4px"
          >
            {{ kw.value || kw }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
